import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const navItems = [
  { name: "About", id: "about" },
  { name: "Skills", id: "skills" },
  { name: "Experience", id: "resume" },
  { name: "Writing", id: "writing" },
  { name: "Projects", id: "projects" },
  { name: "Open Source", id: "open-source" },
  { name: "Contact", id: "contact" }
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={scrolled ? "header-scrolled" : ""}>
      <motion.nav
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <a href="#" className="nav-logo" aria-label="Home">OC</a>
        <button
          className="nav-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span className={`hamburger ${menuOpen ? "open" : ""}`} />
        </button>
        <ul className={menuOpen ? "nav-open" : ""}>
          {navItems.map((item) => (
            <li key={item.id}>
              <a href={`#${item.id}`} onClick={() => setMenuOpen(false)}>
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </motion.nav>
    </header>
  );
};

export default Header;
